import React, { FC } from 'react'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { CheckoutItemType } from 'types/checkoutItem'

type Props = {
  items: CheckoutItemType[]
}

const PrintOrderTotalQuantity: FC<Props> = (props) => {
  const { items } = props
  return (
    <FlexRow justifyContent={'end'}>
      <span className={classNames(text.font_medium, text.font_bold)}>合計点数 :</span>
      <Spacer size={24} />
      <span className={classNames(text.font_medium, text.font_bold)}>
        {items.reduce((prev, item) => prev + item.quantity, 0)}点
      </span>
    </FlexRow>
  )
}

export default PrintOrderTotalQuantity
